import { MatDialog, MatSnackBar } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '../../../../../node_modules/@angular/router';
import { DataService } from 'src/app/services/data.service';
import { AddTrainingProgramComponent } from './add-training-program/add-training-program.component';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-training-program',
  templateUrl: './training-program.component.html',
  styleUrls: ['./training-program.component.scss']
})
export class TrainingProgramComponent implements OnInit {
  PROGRAMS = [];
  SELECTED_PROGRAM: any = null;
  PROCESS: boolean = false;
  ID:string;

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    public store: List,
       public auth: AuthStore,
    public ds: DataService,
  ) { }

  async ngOnInit() {
    this.PROCESS = true;
    this.PROGRAMS = await this.store.fetchList(this.ds.adprogramCollectRef())
    this.route.params.subscribe(async params => {
      const { id } = params;
      this.ID=id;
      this.SELECTED_PROGRAM = await this.store.fetchDoc(this.ds.adprogramCollectRef().doc(id));
      this.store.fetchData(this.ds.trainingProgramRef(ref => ref.where("programKey", "==", id).orderBy('name')))
      this.PROCESS = false;
    })
  }

  create() {
    let dialogRef = this.dialog.open(AddTrainingProgramComponent, {
      data: this.SELECTED_PROGRAM,
      panelClass: 'register-test-overlay-panel',
      width: '35vw',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }
}